'use client';

import { useEffect } from 'react';
import { useCookieConsentStatus } from '@/providers/CookieConsentProvider';
declare global {
  interface Window {
    gtag?: (command: string, ...args: unknown[]) => void;
  }
}

/**
 * Manages Google Tag Manager consent mode
 * Updates consent preferences after user interaction with cookie banner
 * Note: Default consent is set in layout.tsx <head> before GTM loads
 */
export default function GTMConsentMode() {
  const {
    hasAnalyticsConsent,
    hasAdvertisingConsent,
    requiresConsent
  } = useCookieConsentStatus();
  useEffect(() => {
    if (typeof window === 'undefined' || !window.gtag) {
      return;
    }

    // Update GTM consent mode based on user preferences
    window.gtag('consent', 'update', {
      analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
      ad_storage: hasAdvertisingConsent ? 'granted' : 'denied',
      ad_user_data: hasAdvertisingConsent ? 'granted' : 'denied',
      ad_personalization: hasAdvertisingConsent ? 'granted' : 'denied'
    });
  }, [hasAnalyticsConsent, hasAdvertisingConsent, requiresConsent]);
  return null;
}